export const refundPolicy = {
  title: 'Refund policy',
  lastUpdated: '2026-04-23',
  sections: [
    {
      heading: 'Principles',
      body: [
        'We only take on projects we are confident we can deliver. If something goes wrong on our side, we would rather refund you than keep your money and a bad feeling.',
        'This policy applies to the services listed on this website: logo design, website design, and website development.',
      ],
    },
    {
      heading: 'Before work starts',
      body: [
        'If you pay a deposit but we have not yet started work, we refund the deposit in full within fourteen days of your written request.',
        '"Started work" means we have held the discovery call, delivered the written brief, or produced any design or code asset for you.',
      ],
    },
    {
      heading: 'Logo design',
      body: [
        'If after three initial directions and one revision round you decide to end the project, we retain fifty percent of the agreed fee and refund the remaining deposit amount. You receive the working files produced so far with no usage rights until full payment.',
        'After the chosen direction has been refined past the second revision round, deposits are non-refundable. Remaining balance can still be cancelled; work stops and delivered assets remain with us.',
      ],
    },
    {
      heading: 'Website design',
      body: [
        'If you end the project before wireframe sign-off, we retain thirty percent of the agreed fee for discovery work.',
        'After wireframe sign-off and before visual design sign-off, we retain sixty percent.',
        'After visual design sign-off, deposits are non-refundable. Remaining balance can still be cancelled.',
      ],
    },
    {
      heading: 'Website development',
      body: [
        'Development is billed against agreed milestones. Completed and accepted milestones are non-refundable. Uncompleted milestones are refunded in full if cancellation is requested before work on that milestone starts.',
      ],
    },
    {
      heading: 'Bundle packages',
      body: [
        'Bundles are priced as a single unit. Cancellation of one service inside a bundle removes the bundle discount; the remaining services are rebilled at their individual prices.',
      ],
    },
    {
      heading: 'How to request a refund',
      body: [
        'Send an email to business@justsee-ltd.com with the subject line "Refund request" and a short explanation. We respond within two business days and, where a refund is owed, process it within fourteen days to the original payment method.',
      ],
    },
    {
      heading: 'Disputes',
      body: [
        'If we disagree on whether a refund is owed, we first try to resolve it between us. Failing that, Cyprus law and courts apply.',
      ],
    },
  ],
};
